/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentEntity} from '../api'

 export const useQueryGetInvestmentEntity = createReactQueryHook('getInvestmentEntity', getInvestmentEntity)
